import BaseApi from './baseApi';
import IGood from '../models/IGood';
import IAuthentication from '../models/IAuthentication';
export default class GoodsApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Goods");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetGoods() : Promise<IGood[]> {
        let json : string = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var goods: IGood[] = [];
            goods = response.data as IGood[];
            return goods;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveGood(good: IGood) : Promise<string> {
        const json = this.getJsonSave(good);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateGood(good: IGood) : Promise<boolean> {
        const json = this.getJsonUpdate(good);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteGood(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Goods",
            "conditions": [{
                "Item1": "Goods",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(good: IGood) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": good.name
            }, {
                "Item1": "Code",
                "Item2": good.code
            }, {
                "Item1": "EANCode",
                "Item2": good.eanCode
            }, {
                "Item1": "Specifications",
                "Item2": good.specifications
            }, {
                "Item1": "AmountPerBox",
                "Item2": good.amountPerBox
            }, {
                "Item1": "Sku",
                "Item2": good.sku
            }, {
                "Item1": "Weight",
                "Item2": good.weight
            }, {
                "Item1": "CustomsCode",
                "Item2": good.customsCode
            }, {
                "Item1": "AlcoholPercentage",
                "Item2": good.alcoholPercentage
            },
            {
                "Item1": "LitersPerUnit",
                "Item2": good.litersPerUnit
            },
            {
                "Item1": "ExciseCategory",
                "Item2": good.exciseCategory
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Goods"
        };
        return json;
    }

    private getJsonUpdate(good: IGood) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": good.name
            }, {
                "Item1": "Code",
                "Item2": good.code
            }, {
                "Item1": "EANCode",
                "Item2": good.eanCode
            }, {
                "Item1": "Specifications",
                "Item2": good.specifications
            }, {
                "Item1": "AmountPerBox",
                "Item2": good.amountPerBox
            }, {
                "Item1": "Sku",
                "Item2": good.sku
            }, {
                "Item1": "Weight",
                "Item2": good.weight
            }, {
                "Item1": "CustomsCode",
                "Item2": good.customsCode
            }, {
                "Item1": "AlcoholPercentage",
                "Item2": good.alcoholPercentage
            }, {
                "Item1": "LitersPerUnit",
                "Item2": good.litersPerUnit
            }, {
                "Item1": "ExciseCategory",
                "Item2": good.exciseCategory
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Goods",
            "keyvalue": good.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Goods",
                "Item2": "id"
            }, {
                "Item1": "Goods",
                "Item2": "name"
            }, {
                "Item1": "Goods",
                "Item2": "code"
            }, {
                "Item1": "Goods",
                "Item2": "EANCode"
            }, {
                "Item1": "Goods",
                "Item2": "specifications"
            }, {
                "Item1": "Goods",
                "Item2": "amountPerBox"
            }, {
                "Item1": "Goods",
                "Item2": "sku"
            }, {
                "Item1": "Goods",
                "Item2": "weight"
            }, {
                "Item1": "Goods",
                "Item2": "CustomsCode"
            }, {
                "Item1": "Goods",
                "Item2": "AlcoholPercentage"
            }, {
                "Item1": "Goods",
                "Item2": "LitersPerUnit"
            }, {
                "Item1": "Goods",
                "Item2": "ExciseCategory"
            }],
            "tables": [{
                "Item1": "Goods"
            }],
            "conditions": [{
                "Item1": "Goods",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }],
            "orderBy": [{
                "Item1": "Goods.name"
            }]
        };
        return json;
    }
}
